import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import { Grid } from '@mui/material';
import { TaxationSystemEnum } from '../../enum/TaxationSystemEnum';
import useAccount from '../../hooks/useAccount';
import { updateAgentProfile } from '../../api/agent';
import useClosableSnackbar from '../../hooks/useClosableSnackbar';
import { errorToString } from '../../helpers/Helper';
import MfButton from '../UI/Button/MfButton';
import { AccountType } from '../../enum/AccountType';
import SelectAdapter from '../FinalFormAdapters/SelectAdapter';
import RadioGroupAdapter from '../FinalFormAdapters/RadioGroupAdapter';
import MfLinearSimpleProgress from '../UI/Progress/MfLinearSimpleProgress';

interface FormValues {
  taxationSystem: TaxationSystemEnum;
}

const taxationLabels = {
  [TaxationSystemEnum.NPD]: 'Налог на профессиональный доход',
  [TaxationSystemEnum.OSN]: 'Общая система налогообложения',
  [TaxationSystemEnum.USN]: 'Упрощенная система налогообложения',
  [TaxationSystemEnum.NDFL]: 'НДФЛ',
  [TaxationSystemEnum.PATENT]: 'Патентная система налогообложения',
};

const legalTaxation = [
  TaxationSystemEnum.OSN,
  TaxationSystemEnum.USN,
  TaxationSystemEnum.PATENT,
];

const legalTaxationOptions = legalTaxation.map((value) => ({
  label: taxationLabels[value],
  value,
}));

const TaxationSystemForm = () => {
  const [processing, setProcessing] = useState(false);
  const { accountResponse, fetchAccountResponse } = useAccount();
  const { showSnackbar } = useClosableSnackbar();

  const submit = async (values: FormValues) => {
    setProcessing(true);
    try {
      await updateAgentProfile(values);
      await fetchAccountResponse();
    } catch (e) {
      showSnackbar(errorToString(e));
    }
    setProcessing(false);
  };

  if (!accountResponse) {
    return <MfLinearSimpleProgress />;
  }

  return (
    <Form
      initialValues={{
        taxationSystem: accountResponse?.agentProfileInfo?.taxationSystem,
      }}
      onSubmit={submit}
      render={({ handleSubmit, submitting, pristine }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {accountResponse?.type === AccountType.PERSON && (
                <Field
                  name="taxationSystem"
                  label="Являетесь ли вы налогоплательщиком налога на профессиональный доход (самозанятым)?"
                  component={RadioGroupAdapter}
                  items={[
                    {
                      value: TaxationSystemEnum.NPD,
                      label: 'Да',
                    },
                    {
                      value: TaxationSystemEnum.NDFL,
                      label: 'Нет',
                    },
                  ]}
                />
              )}
              {[AccountType.IP, AccountType.LEGAL].includes(
                accountResponse?.type
              ) && (
                <Field
                  name="taxationSystem"
                  label="Выберите систему налогообложения"
                  items={legalTaxationOptions}
                  component={SelectAdapter}
                />
              )}
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'right' }}>
              <MfButton
                disabled={submitting || pristine || processing}
                type="submit"
                variant="contained"
              >
                Сохранить систему налогообложения
              </MfButton>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default TaxationSystemForm;
